<div class="container-image-preview py-2 px-4 md:py-4 md:px-8 xl:py-8 xl:px-16">
    <img class="mx-auto max-h-full" [src]="sanitizedBlobUrl" [alt]="fileName" />
</div>
